import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, CardTitle, CardText } from "react-md/lib/Cards";
import { DataTable, TableHeader, TableBody, TableRow, TableColumn } from "react-md/lib/DataTables";
import { MSpinner } from "components/Shared";
import { dateToString } from "components/Shared/Formatters";

const GaarResults = ({ gaarResults, fetchingGaarResults, getControlMethods }) => {
  const [expanded, setExpanded] = useState(gaarResults && Object.keys(gaarResults).length ? true : false);
  const [currentResults, setCurrentResults] = useState(gaarResults);
  const ref = useRef();
  const mounted = useRef(true);

  useEffect(() => {
    return () => { mounted.current = false; };
  }, []);

  useEffect(() => {
    if (gaarResults && Object.keys(gaarResults).length && resultsAreNew(gaarResults)) {
      updateResults(gaarResults);
    }
  }, [gaarResults]);

  const resultsAreNew = (newResults) => {
    if (!currentResults || !Object.keys(currentResults).length) { return true; }
    const differentLength = newResults.ruleFirings?.length !== currentResults.ruleFirings?.length;
    if (differentLength) { return true; }
    const currentIds = currentResults.ruleFirings?.map(r => r.id);
    const differentIds = newResults.ruleFirings?.filter(r => !currentIds?.includes(r.id));
    if (differentIds?.length) { return true; }
    return false;
  };

  const updateResults = (newResults) => {
    setCurrentResults(newResults);
    if (!expanded) { toggleExpanded(); }
  };

  const toggleExpanded = () => setExpanded(!expanded);
  
  const openCard = () => setExpanded(true);

  if (getControlMethods) getControlMethods({ ref: ref, openCard: openCard });

  if (fetchingGaarResults) return <MSpinner />;

  const showResults = currentResults?.ruleFirings?.length > 0;

  return (
    <div className="case-header" ref={ref}>
      <Card
        className="md-cell md-cell--12"
        expanded={expanded}
        onExpanderClick={toggleExpanded}
      >
        <CardTitle
          title={"GAAR Results"}
          style={{ cursor: "pointer" }}
          expander
          onClick={toggleExpanded}
        />
        <CardText expandable>
          {showResults &&
            <DataTable plain className="md-cell--12">
              <TableHeader>
                <TableRow>
                  <TableColumn>Message</TableColumn>
                  <TableColumn>Reviewed By</TableColumn>
                  <TableColumn>Reviewed Date</TableColumn>
                </TableRow>
              </TableHeader>
              <TableBody>
                {gaarResults.ruleFirings.map(
                  ({ id, ruleMessage, reviewedByInternetUser, reviewedOnUtc }) => (
                    <TableRow key={id}>
                      {/* eslint-disable-next-line react/no-danger */}
                      <TableColumn><div dangerouslySetInnerHTML={{ __html: ruleMessage }} /></TableColumn>
                      <TableColumn>{reviewedByInternetUser?.fullName}</TableColumn>
                      <TableColumn>{dateToString(reviewedOnUtc)}</TableColumn>
                    </TableRow>
                  ))}
              </TableBody>
            </DataTable>}
          {!showResults && gaarResults &&
            <div className="md-cell--12">No GAAR rules triggered.</div>}
          {!gaarResults &&
            <div className="md-cell--12">No GAAR results.</div>}
        </CardText>
      </Card>
    </div>
  );
};

GaarResults.propTypes = {
  gaarResults: PropTypes.object,
  fetchingGaarResults: PropTypes.bool,
  getControlMethods: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    gaarResults: state.validation.gaarResults,
    fetchingGaarResults: state.validation.fetchingGaarResults,
  };
};

export default connect(mapStateToProps)(GaarResults);